import { BusinessSubscription } from "lens-platform-sdk";
import { isLensProPlan } from "src/services/plans";

/**
 * Returns true if the LBID's subscriptions has at least one active Lens Pro subscription
 */
export const hasActiveLensPro = (businessSubscriptions: Array<BusinessSubscription>) => {
  if (process.env.NODE_ENV === "development") {
    return true;
  }

  return businessSubscriptions.some(
    (subscription) => subscription.state === "active" && isLensProPlan(subscription.planCode),
  );
};
